import { useQuery } from "@tanstack/react-query";
import { sendAjaxRequest } from "@/ts/api/comunicacion";
import { BaseModal, ModalCloseCross, type BaseModalProps } from "@/components/modals/BaseModal";
import { TablaInfoPedido } from "./TablaInfoPedido";

interface ModalInformacionPedidoProps extends BaseModalProps {
	readonly idPedido: number;
}
export function ModalInformacionPedido(props: ModalInformacionPedidoProps) {
	const { data, isPending, error } = useInfoPedido({ idPedido: props.idPedido });

	// if (isLoading) return <div>Cargando...</div>;
	// if (isError) return <div>Error al cargar la información del pedido</div>;
	// if (data == null) return <div>No se ha encontrado el pedido</div>;

	const slugPedido = data ? `| ${data.nombreCliente} | ${data.fechaPedido}` : "";

	return (
		<BaseModal show={props.show} close={props.close}>
			<div className="modal-header">
				<h4 className="modal-title" >
					Pedido {props.idPedido} {slugPedido}
				</h4>
				<ModalCloseCross onClick={props.close} />
			</div>
			<div className="modal-body">
				<div className="table-responsive">
					<TablaInfoPedido
						data={data?.lineas ?? []}
						isPending={isPending}
						errMessage={error?.message ?? null}
					/>
				</div>
			</div>
			<div className="modal-footer">
				<button type="button" className="btnSecondary" onClick={props.close}>Cerrar</button>
			</div>
		</BaseModal>
	);
}

export function useInfoPedido(pedido: { idPedido: number; }) {
	return useQuery<InfoPedido>({
		queryKey: ["getInfoPedidoVenta", pedido.idPedido],
		queryFn: () => sendAjaxRequest<InfoPedido>("GET", "/api/v1/getInfoPedidoVenta", { "idPedido": pedido.idPedido }),
	});
}
export interface InfoPedido {
	nombreCliente: string;
	fechaPedido: string;
	lineas: LineaPedido[];
}
export interface LineaPedido {
	idLinea: string,
	idArticulo: string | null,
	descripcion: string | null,
	cantidad: number | null,
	cantidadEmpaquetada: number | null,
}